import { Component, OnInit } from '@angular/core';
import {HttpRequestService} from './../../_services/http-request.service';
import { CommonService } from './../../_services/common.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute} from '@angular/router';
import { Meta, Title, DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-cms-page',
  templateUrl: './cms-page.component.html',
  styleUrls: ['./cms-page.component.scss']
})
export class CmsPageComponent implements OnInit {
  pageDetails:any = {
    title:'',
    description:''
  };
  constructor(private httpServices:HttpRequestService,
		public router: Router,
		private toastr: ToastrService,
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute,
    public translate: TranslateService,
    private title: Title, private meta: Meta,
    public sanitizer: DomSanitizer
    ) {
      this.commonService.activelang.subscribe((lang) => {
        // this language will be used as a fallback when a translation isn't found in the current language
        translate.setDefaultLang(lang);
      
        // the lang to use, if the lang isn't available, it will use the current loader to get them
        translate.use(lang);
        });
    }

  ngOnInit() {
    this.activatedRoute.params.subscribe((paramData)=>{
      if (paramData.pageSlug) {
        this.httpServices.setModule('action').post('cms_details',{"lang":"EN",
        "slug":paramData.pageSlug}).subscribe((response) => {
					if(response.status === 'error') {
            if (response.code === 'CC-CD-0004') {
              this.router.navigate(['/page-not-found']);
            } else {
              this.toastr.error( response.data,'Error:');
            }
					} else {
            this.pageDetails = response.data;
            this.title.setTitle(response.data.meta_title);
            this.meta.updateTag({ name: 'og:title', content: response.data.meta_title })
            this.meta.updateTag({ name: 'og:keyword', content: response.data.meta_keyword })
            this.meta.updateTag({ name: 'og:description', content: response.data.meta_description })
					}
				});
      }
  });
  }

}
